import { jsx as l } from "react/jsx-runtime";
import "react";
var v = (r) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...r,
  children: /* @__PURE__ */ l("path", {
    fill: "currentColor",
    d: "M31.16 12.108 18.56 6.1a2.032 2.032 0 0 0-1.26 0L4.7 12.108c-.42.268-.7.668-.7 1.202 0 .534.28.935.84 1.202l1.96.934v6.543c0 .534.28.934.7 1.201l6.3 3.338c1.26.668 2.8 1.069 4.2 1.069.98 0 1.96-.134 2.8-.534v-2.938c-1.68.935-3.92.935-5.6 0l-5.6-3.07v-4.407l7.84 3.739c.14.267.28.267.56.267s.42 0 .56-.134l3.64-1.736v9.881c0 .8.56 1.335 1.4 1.335.84 0 1.4-.534 1.4-1.335V25.06l3.5-1.87c.42-.267.7-.667.7-1.201v-6.543l1.96-.934c.56-.267.84-.668.84-1.202 0-.534-.28-.934-.84-1.202Zm-4.76 9.08-1.4.8V17.45l1.4-.667v4.406ZM18 17.85l-9.52-4.54L18 8.77l9.52 4.54L18 17.85Z"
  })
});
export {
  v as default
};
